import axios from 'axios';
import Vue from 'vue';
import { get } from 'lodash';

// initial state
const state = {
  clippedCouponIds: [], //clippedCouponIdsSinceLastRefresh
  gtmClickedProductIds: [], //Clicked products since last refresh. GTM e_productClick should only be triggered once per product
  firstSearchResultInteractionFired: false, // We fire events for add-to-cart, add-to-list, pdp-click-through. Resets every pageload. 
  contactInfo: {
    phoneNumber: ''
  },
  paymentMethods: [], // holds all payment methods (credit + ebt)
  paymentMethodsLoading: false,
  paymentMethodsLoaded: false,
  ebtCards: [], // holds ebt payment methods
  creditCards: [], // holds non-ebt payment methods
  hpgIframeUrl: '',
  hpgIframeUrlLoading: false,
  activeCardAlias: '',
  upsells: {
    featuredProductRecommendations: [],
    cartProductRecommendations: [],
    cartProductRecommendationsDisplayName: "Popular products",
    shoppingListRecommendations: [],
    frequentlyPurchasedProductRecommendations: [],
    forgottenProductRecommendations: [],
  },
  globalModals: {
    id: '',
    shown: true,
    options: {}
  },
  // COVID: Remove once healthcare program is done
  isHealthcareWorker: false,
}

// getters
const getters = {
  hasCreditAdded: state => state.creditCards.length > 0,
}

// actions
const actions = {
  FETCH_SAVED_CREDIT_CARDS ({ COMMIT }, paymentAliasToSetAsActive) {
    // Optional: paymentAliasToSetAsActive

    var vm = this

    vm.commit("profile/SET_PAYMENT_METHODS_LOADING", true);
    vm.commit("profile/SET_PAYMENT_METHODS_LOADED", false);
    vm.commit("errors/CLEAR_ERROR_TYPE", "paymentMethods");

    return axios
      .all([
        axios.get('/commerce-api/v1/hpg/list')
      ])
      .then(
        axios.spread((response) => {
          vm.commit('profile/SET_PAYMENT_METHODS', response.data.items);

          if(typeof paymentAliasToSetAsActive !== 'undefined'){
            vm.commit('profile/SET_ACTIVE_CARD', paymentAliasToSetAsActive)
          }

          // HUP-2052: clear errors when at least one credit card is successfully returned,
          // removes gift card error message for missing credit card, if displayed.
          if (response.data != undefined && response.data.items != undefined && Object.keys(response.data.items).length > 0) {
        	  vm.commit('errors/CLEAR_ERRORS')
          }
          // TODO revisit this - which error to clear and when?
          // let hasCreditCard = paymentMethods.some(card =>
          //   // we can consider a payment method to be a credit card if it isn't snap or tanf
          //   !!card.paymentAlias && (!card.paymentAlias.ebtSnap && !card.paymentAlias.ebtTanf)
          // );
          // if (hasCreditCard) {
          //   vm.commit('errors/CLEAR_ERRORS')
          // }
        })
      )
      .catch((error) => {
        // Error
        if (error.response) {
          vm.commit('errors/PUSH_ERROR', {message: 'HPG: ' + error.response.data.title, code: error.response.status})
        } else if (error.request) {
          vm.commit('errors/PUSH_ERROR', {message: 'Couldn\'t contact the website'})
          console.log(error.request)
        } else {
          console.log('Error', error.message)
          vm.commit('errors/PUSH_ERROR', {message: error.message})
        }
        console.log(error.config)
      })
      .finally(() => {
        vm.commit("profile/SET_PAYMENT_METHODS_LOADING", false);
      })
  },
  FETCH_HPG_IFRAME_URL ({ COMMIT }) {
    var vm = this
    vm.commit('profile/SET_HPG_IFRAME_URL_LOADING', true)

    axios
      .all([
        axios.get('/commerce-api/v1/hpg/iframe')
      ])
      .then(
        axios.spread((response) => {
          vm.commit('profile/SET_HPG_IFRAME_URL', response.data.url)
          vm.commit('profile/SET_HPG_IFRAME_URL_LOADING', false)
        })
      )
      .catch((error) => {
        vm.commit('profile/SET_HPG_IFRAME_URL_LOADING', false)

        // Error
        if (error.response) {
          vm.commit('errors/PUSH_ERROR', {message: 'HPG: ' + error.response.data.title, code: error.response.status})
        } else if (error.request) {
          vm.commit('errors/PUSH_ERROR', {message: 'Couldn\'t contact the website'})
          console.log(error.request)
        } else {
          console.log('Error', error.message)
          vm.commit('errors/PUSH_ERROR', {message: error.message})
        }
        console.log(error.config)
      })
  },
  FETCH_UPSELL ({ COMMIT }, endpoint) {
    var vm = this

    // endpoint = {
    //   name: "featuredProductRecommendations",
    //   count: 30 // optional
    // }

    var params = {}
    if (endpoint.count) { params.count = endpoint.count }

    return axios
      .all([
        axios.get('/commerce-api/v1/cart/upsell/' + endpoint.name, {
          params: params
        })
      ])
      .then(
        axios.spread((response) => {
          vm.commit('profile/SET_UPSELL', {endpoint: endpoint.name, response: response})
          return response.status
        })
      )
      .catch((error) => {
        // Error
        if (error.response) {
          vm.commit('errors/PUSH_ERROR', {message: error.response.data.title, code: error.response.status})
        } else if (error.request) {
          vm.commit('errors/PUSH_ERROR', {message: 'Couldn\'t contact the website'})
          console.log(error.request)
        } else {
          console.log('Error', error.message)
          vm.commit('errors/PUSH_ERROR', {message: error.message})
        }
        console.log(error.config)
        return _.get(error, 'response.status', 400)
      })

  },
  POST_PRIMARY_CARD ({ COMMIT }, paymntAlias) {
    // Sets the primary card to paymntAlias
    var vm = this
    vm.commit('errors/CLEAR_ERRORS')
    // no body

    axios
      .all([
        axios.post('/commerce-api/v1/hpg/' + paymentAlias + '/primary')
      ])
      .then(
        axios.spread((response) => {
          //refresh credit cards
          this.$store.dispatch('profile/FETCH_SAVED_CREDIT_CARDS')
        })
      )
      .catch((error) => {
        // Error
        if (error.response) {
          vm.commit('errors/PUSH_ERROR', {message: error.response.data.title, code: error.response.status, type: 'general'})
        } else if (error.request) {
          vm.commit('errors/PUSH_ERROR', {message: 'Couldn\'t contact the website'})
          console.log(error.request)
        } else {
          console.log('Error', error.message)
          vm.commit('errors/PUSH_ERROR', {message: error.message, type: 'general'})
        }
        console.log(error.config)
      })
  },
  UPDATE_CARD ({ COMMIT }, { paymentAlias, body }) {
    var vm = this
    
    vm.commit('errors/CLEAR_ERRORS')

    axios
      .all([
        axios.post(`/commerce-api/v1/hpg/${paymentAlias}/update`, body)
      ])
      .then(
        axios.spread((response) => {
          //response is existing credit cards, with the updated one
          console.log('SUCCESS?', response);
          vm.commit('profile/SET_PAYMENT_METHODS', response.data.items)
        })
      )
      .catch((error) => {
        // Error
        if (error.response) {
          vm.commit('errors/PUSH_ERROR', {message: 'HPG: ' + error.response.data.title, code: error.response.status})
        } else if (error.request) {
          vm.commit('errors/PUSH_ERROR', {message: 'Couldn\'t contact the website'})
          console.log(error.request)
        } else {
          console.log('Error', error.message)
          vm.commit('errors/PUSH_ERROR', {message: error.message})
        }
        console.log(error.config)
      })
  },
  DELETE_CARD ({ COMMIT }, paymentAlias) {
    var vm = this

    axios
      .all([
        axios.delete('/commerce-api/v1/hpg/delete/' + paymentAlias)
      ])
      .then(
        axios.spread((response) => {
          //response is existing credit cards
          vm.commit('profile/SET_PAYMENT_METHODS', response.data.items)
          vm.dispatch('cart/LOAD_CART') // Need to refresh payment groups
        })
      )
      .catch((error) => {
        // Error
        if (error.response) {
          vm.commit('errors/PUSH_ERROR', {message: 'HPG: ' + error.response.data.title, code: error.response.status})
        } else if (error.request) {
          vm.commit('errors/PUSH_ERROR', {message: 'Couldn\'t contact the website'})
          console.log(error.request)
        } else {
          console.log('Error', error.message)
          vm.commit('errors/PUSH_ERROR', {message: error.message})
        }
        console.log(error.config)
      })
  },
}

// mutations
const mutations = {
  SET_PAYMENT_METHODS (state, items = []) {
    let ebtCards = items.filter(item => get(item.paymentAlias, 'ebtSnap', false));
    let creditCards = items.filter(item => 
      item.paymentAlias && (!item.paymentAlias.ebtSnap && !item.paymentAlias.ebtTanf)
    );

    state.paymentMethods = items;
    state.creditCards = creditCards;
    state.ebtCards = ebtCards;

    // Set the default card as the payment method
    var defaultCard = creditCards.find(function (paymentMethod) {
      return paymentMethod.isDefault === true
    })

    if (defaultCard && !defaultCard.isExpired) {
      state.activeCardAlias = defaultCard.paymentAlias.paymentAlias
    }

    if (!defaultCard) {
      state.activeCardAlias = ''
    }

    state.paymentMethodsLoaded = true;
  },
  SET_PAYMENT_METHODS_LOADING(state, isLoading) {
    state.paymentMethodsLoading = isLoading;
  },
  SET_PAYMENT_METHODS_LOADED(state, isLoaded) {
    state.paymentMethodsLoaded = isLoaded;
  },
  SET_ACTIVE_CARD (state, paymentAlias) {
    state.activeCardAlias = paymentAlias
  },
  SET_HPG_IFRAME_URL (state, data) {
    state.hpgIframeUrl = data
  },
  SET_HPG_IFRAME_URL_LOADING (state, boolean) {
    state.hpgIframeUrlLoading = boolean
  },
  SET_CONTACT_INFO (state, data) {
    Vue.set(state, 'contactInfo', data)
  },

  SET_UPSELL (state, body) {
    Vue.set(state.upsells, body.endpoint, body.response.data.productItems)
    if (body.endpoint === 'cartProductRecommendations') {
      Vue.set(state.upsells, 'cartProductRecommendationsDisplayName', body.response.data.displayName)
    }
  },

  OPEN_MODAL (state, data) {
    console.log('open modal')
    Vue.set(state, 'globalModals', {
      id: data.id,
      shown: true,
      options: data.options
    })
  },
  CLOSE_MODAL (state, data) {
    console.log('close modal')
    Vue.set(state, 'globalModals', {
      id: '',
      shown: false,
      options: ''
    })
  },
  TOGGLE_GLOBAL_MODAL (state, value) {
    if (!value) {
      state.globalModals.shown = !state.globalModals.shown
    } else {
      state.globalModals.shown = value
    }
  },
  PUSH_CLIPPED_COUPON_ID (state, couponId){
    // Used to keep frontend in sync until all coupons are converted to JSON
    state.clippedCouponIds.push(couponId)
  },
  PUSH_CLICKED_PRODUCT_ID (state, id){
    // GTM event e_productClick should only be triggered once per product, per page load
    state.gtmClickedProductIds.push(id)
  },
  SET_FIRST_SEARCH_INTERACTION (state){
    // Upon first add-to-cart, add-to-list or click-through. Resets every pageload. 
    state.firstSearchResultInteractionFired = true;
  },
  // COVID: Remove once healthcare program is done
  GET_IS_HEALTHCARE_WORKER(state) {
    // Only look for the saved localStorage value if the med timeslots feature is on
    const medTimeslotsEnabled = get(window, 'heb.data.features.HATCH_662_SUPPORT_MED_TIMESLOTS', false);
    state.isHealthcareWorker = medTimeslotsEnabled && window.localStorage.getItem('isHealthcareWorker') === "true";
  },
  // COVID: Remove once healthcare program is done
  SET_IS_HEALTHCARE_WORKER(state, value = false) {
    window.localStorage.setItem('isHealthcareWorker', value);
    state.isHealthcareWorker = value;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
